module.exports = __webpack_public_path__ + "static/img/slave.2c3608e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/slave.jpg
// module id = LeB6
// module chunks = 1